import { useEffect, useState } from "react";
import { Crown, Flag, Trophy } from "lucide-react";
import { api } from "@/lib/api";
import GoalCelebration from "@/pages/team/GoalCelebration";

// Weekly (resets Monday) Pac-Man race: each lister's Pac-Man has eaten one $ per item listed; a flag marks their goal.
export default function Leaderboard({ compact = false }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    const load = () => api.get("/photo-batches/leaderboard", { params: { tz: new Date().getTimezoneOffset() } }).then(({ data: d }) => setData(d)).catch(() => {});
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, 5 * 60000);
    return () => clearInterval(t);
  }, []);
  if (!data?.board?.length) return null;
  const scale = Math.max(1, ...data.board.map((r) => Math.max(r.count, r.goal || 0)));
  const mine = data.board.find((r) => r.me);
  return (
    <section className={`rounded-xl bg-slate-950 p-4 text-white ${compact ? "mb-4" : "mt-6"}`} data-testid="lister-leaderboard">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="flex items-center gap-1.5 font-['Space_Grotesk'] text-base font-bold"><Trophy className="h-4 w-4 text-[#facc15]" /> This week's listing race</h2>
        <span className="font-mono text-[10px] uppercase tracking-wider text-slate-400">Resets Monday</span>
      </div>
      <ol className="space-y-2.5">
        {data.board.map((r, i) => {
          const pct = (r.count / scale) * 100;
          const hit = r.goal > 0 && r.count >= r.goal;
          return (
            <li key={r.id} data-testid={`leaderboard-row-${i}`}>
              <div className="mb-1 flex items-center justify-between text-xs">
                <span className={r.me ? "font-bold text-[#facc15]" : "text-slate-200"}>
                  <span className="mr-1.5 font-mono text-slate-500">{i + 1}</span>{r.name}{r.me ? " (you)" : ""}
                  {i === 0 && r.count > 0 && <Crown className="ml-1 inline h-3 w-3 text-[#facc15]" data-testid="leaderboard-crown" />}
                </span>
                <b className={`font-mono ${hit ? "text-emerald-400" : ""}`} data-testid={`leaderboard-count-${i}`}>
                  {r.count}{r.goal > 0 && <span className="font-normal text-slate-400"> / {r.goal}</span>}{hit && " ✓"}
                </b>
              </div>
              <span className="lp-track" style={{ "--pm": "14px", background: "#1e293b" }} aria-hidden="true">
                {Array.from({ length: 10 }, (_, d) => {
                  const at = ((d + 1) / 11) * 100;
                  return <span key={d} className={`lp-dollar ${at <= pct ? "lp-eaten" : ""}`} style={{ left: `${at}%` }}>$</span>;
                })}
                {r.goal > 0 && (
                  <Flag className={`absolute top-0.5 h-2.5 w-2.5 ${hit ? "text-emerald-400" : "text-rose-400"}`}
                    style={{ left: `calc(${(r.goal / scale) * 100}% - 8px)` }} data-testid={`leaderboard-goal-flag-${i}`} />
                )}
                <span className="lp-man pm-man" style={{ left: `calc(${pct}% - ${pct ? 14 : 0}px)` }}>
                  <span className="pm-jaw pm-top" /><span className="pm-jaw pm-bottom" />
                </span>
              </span>
            </li>
          );
        })}
      </ol>
      {mine && mine.goal > 0 && mine.count >= mine.goal && <GoalCelebration week={data.since} count={mine.count} goal={mine.goal} />}
    </section>
  );
}
